import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React from "react";

import { underV3 } from "@/components/ui/v3/flagged";
import { cn } from "@/lib/utils";

// v3.2 (VITE_APP_REDESIGN_ENABLED): tooltips are portalled outside the
// .v3-remap shell, so they take the v3 ink chip directly.
export const V3_TOOLTIP =
  "rounded-lg bg-v3-ink px-2.5 py-1.5 font-v3 text-[12.5px] font-medium leading-snug text-v3-on-ink shadow-v3-pop";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      data-testid="tooltip-content"
      sideOffset={sideOffset}
      className={cn(
        "z-50 overflow-hidden rounded-md bg-foreground px-3 py-1.5 text-xs text-background animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        underV3(V3_TOOLTIP),
        className,
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
